<script>
import ApprTemp1 from "../templates/approach/ApprTemp1.vue";
import ApprTemp2 from "../templates/approach/ApprTemp2.vue";
import ApprTemp3 from "../templates/approach/ApprTemp3.vue";
import ApprTemp4 from "../templates/approach/ApprTemp4.vue";
import ApprTemp5 from "../templates/approach/ApprTemp5.vue";
import ApprTemp6 from "../templates/approach/ApprTemp6.vue";
import SelectDropdown from "../SelectDropdown.vue";
import StyleBox from "../StyleBox.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import InputField from "../InputField.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import AppButton from "../AppButton.vue";
import { isApproachReady } from "@/utils/proposalValidation";
import img1 from "@/assets/images/templates/ApprTemp1.png";
import img2 from "@/assets/images/templates/ApprTemp2.png";
import img3 from "@/assets/images/templates/ApprTemp3.png";
import img4 from "@/assets/images/templates/ApprTemp4.png";
import img5 from "@/assets/images/templates/ApprTemp5.png";
import img6 from "@/assets/images/templates/ApprTemp6.png";
import { arrowDownIcon } from "@/utils/proposalIcons";
import TextEditor from "../TextEditor.vue";
import util from "@/utils/util.js";

export default {
    name: "StepApproach",
    components: {
        ApprTemp1, ApprTemp2, ApprTemp3, ApprTemp4, ApprTemp5, ApprTemp6,
        SelectDropdown,
        StyleBox,
        ColorSchemeBox,
        ProjectsDropdown,
        InputField,
        PreviewTemplates,
        AppButton,
        TextEditor,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            warnings: {},
            openQuestionIndex: {},
            expandedBlockId: this.proposal.approach.blocks && this.proposal.approach.blocks[0] ? this.proposal.approach.blocks[0].id : null,
            TemplateList: [
                { label: '1- Display questions in 2 column portrait layout', value: 1, preview: img1, orientation: "portrait", style: this.getTemplateStyle(1) },
                { label: '2- Display questions in 1 column portrait layout', value: 2, preview: img2, orientation: "portrait", style: this.getTemplateStyle(2) },
                { label: '3- Display questions in 3 column portrait layout with 3rd column showing 2 projects each page', value: 3, preview: img3, orientation: "portrait", style: this.getTemplateStyle(3) },
                { label: '1- Display questions in 2 column landscape layout', value: 4, preview: img4, orientation: "landscape", style: this.getTemplateStyle(4) },
                { label: '2- Display questions in 1 column landscape layout', value: 5, preview: img5, orientation: "landscape", style: this.getTemplateStyle(5) },
                { label: '3- Display questions in 3 column landscape layout with 3rd column showing 2 projects each page', value: 6, preview: img6, orientation: "landscape", style: this.getTemplateStyle(6) },
            ],
            arrowDownIcon,
        };
    },
    computed: {
        previewText() {
            const blocks = this.proposal.approach.blocks || [];
            if (!blocks.length) return "Add a block to preview";

            for (let i = 0; i < blocks.length; i++) {
                const block = blocks[i];
                const label = `Block ${i + 1}`;
                if (!block.template) return `${label}: Select template to preview`;
                if (!block.questions || block.questions.length === 0) return `${label}: Add minimum one question to preview`;
                if (block.questions.some((q) => !q.heading || !q.response || q.heading.trim() === "" || q.response.trim() === "")) {
                    return `${label}: Fill the heading and content of every question to preview`;
                }
            }
            return "";
        },
        isPreviewable() {
            return isApproachReady(this.proposal.approach);
        }
    },
    watch: {
        proposal: {
            handler(newVal) {
                if (newVal.approach) {
                    if (!newVal.approach.blocks || newVal.approach.blocks.length === 0) {
                        const initialQuestions = newVal.approach.questions && newVal.approach.questions.length > 0
                            ? newVal.approach.questions
                            : [{ id: Date.now(), heading: "", question: "", response: "" }];

                        const blockId = "block_1";
                        newVal.approach.blocks = [
                            {
                                id: blockId,
                                template: newVal.approach.template || "",
                                style: newVal.approach.style || null,
                                projects: newVal.approach.projects || [],
                                questions: initialQuestions.map((q, idx) => ({
                                    ...q,
                                    id: q.id || `q_1_${idx}_${Date.now()}`
                                })),
                            }
                        ];
                        if (!this.openQuestionIndex[blockId]) {
                            this.$set(this.openQuestionIndex, blockId, 0);
                        }
                    } else {
                        newVal.approach.blocks.forEach((block, bIdx) => {
                            if (!block.id) this.$set(block, 'id', `block_${bIdx}_${Date.now()}`);
                            if (!block.questions || block.questions.length === 0) {
                                this.$set(block, 'questions', [{ id: Date.now(), heading: "", question: "", response: "" }]);
                            }
                            block.questions.forEach((q, qIdx) => {
                                if (!q.id) this.$set(q, 'id', `q_${bIdx}_${qIdx}_${Date.now()}`);
                            });

                            if (this.expandedBlockId === block.id && this.openQuestionIndex[block.id] === undefined) {
                                this.$set(this.openQuestionIndex, block.id, 0);
                            }
                        });
                    }

                    if (newVal.approach.blocks) {
                        newVal.approach.blocks.forEach(block => {
                            block.title = newVal.approach.title;
                            block.opprName = newVal.approach.opprName;
                            block.logo = newVal.approach.logo;
                            block.submittedBy = newVal.approach.submittedBy;
                        });
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getTemplateStyle(t) {
            return {
                colorScheme: {
                    header: "#545454",
                    footer: "#545454",
                    body: "#959595",
                },
                heading: {
                    color: "#000000",
                    size: "18",
                    font: "Arial",
                    bold: true,
                    italic: false,
                    underline: false,
                },
                label: {
                    color: "#ffffff",
                    size: "14",
                    font: "Arial",
                    bold: true,
                    italic: false,
                    underline: false,
                },
                text: {
                    color: "#000000",
                    size: "14",
                    font: "Arial",
                    bold: false,
                    italic: false,
                    underline: false,
                },
            };
        },
        fixStyling(block) {
            const match = this.TemplateList.find(item => item.value === block.template);
            if (match) block.style = match.style;
        },
        handleTemplateSelection(selectedTemplate, block) {
            block.template = selectedTemplate;
            if (selectedTemplate !== 3 && selectedTemplate !== 6) {
                block.projects = [];
            }
            this.fixStyling(block);
        },
        handleProjectSelection(selectedNames, block) {
            block.projects = selectedNames;
        },
        toggleQuestion(blockId, index) {
            const current = this.openQuestionIndex[blockId] === index ? null : index;
            this.$set(this.openQuestionIndex, blockId, current);
        },
        addQuestion(block) {
            const blockId = block.id;
            if (block.questions.some((q) => !q.heading || !q.response || q.heading.trim() === "" || q.response.trim() === "")) {
                this.$set(this.warnings, blockId, "All previous headings and responses must be filled");
                setTimeout(() => {
                    this.$set(this.warnings, blockId, "");
                }, 3000);
                return;
            }
            const newQuestion = { id: Date.now(), heading: "", question: "", response: "" };
            block.questions.push(newQuestion);

            const newIndex = block.questions.length - 1;
            this.$set(this.openQuestionIndex, blockId, newIndex);
        },
        removeQuestion(block, index) {
            block.questions.splice(index, 1);
        },
        async handleGenerateResponse(question) {
            if (!question.question.trim()) return;
            try {
                const prompt = `Write a clear, detailed, and professional response to the following project-specific question: "${question.question}".
Divide the response into multiple paragraphs of 150-200 words each and use <br><br> tag between each paragraph. The response should be suitable for inclusion in a professional proposal and reflect technical understanding, responsibility, and attention 
to quality. Maintain a factual and objective tone. Do not use headings. Avoid marketing language, generic statements, or exaggerated claims.`;

                const response = await this.$store.dispatch("generateAIResponse", prompt);
                if (response) {
                    question.response = response;
                }
            } catch (error) {
                console.error("Failed to generate response:", error);
            }
        },
        addBlock() {
            if (!this.proposal.approach.blocks) this.$set(this.proposal.approach, 'blocks', []);
            const blockId = "block_" + Date.now();
            const newBlock = {
                id: blockId,
                template: "",
                style: null,
                projects: [],
                questions: [{ id: Date.now(), heading: "", question: "", response: "" }],
            };
            this.proposal.approach.blocks.push(newBlock);
            this.expandedBlockId = newBlock.id;
            this.$set(this.openQuestionIndex, blockId, 0);
        },
        removeBlock(index) {
	        let content = {
		      titleText: 'Confirm Delete',
		      message1: `Are you sure you want to remove the block?`		
	         };
	        let cm = util.fn_getModal_confirm(this, content);

	        this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		    if (!resp) return;
                this.proposal.approach.blocks.splice(index, 1);
          });
    }
   }
};
</script>


<template>
  <div class="d-flex flex-column w-100 bg-white rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Project Questions</h4>

      <div class="row">
        <div class="col-12 mb-3">
          <InputField label="Page Title" :modelValue="proposal.approach.title" placeholder="Enter Page Title"
            @update:modelValue="proposal.approach.title = $event" />
        </div>
      </div>

      <div v-for="(block, bIdx) in proposal.approach.blocks" :key="block.id || bIdx"
        class="block-container border mb-4 rounded">
        <div class="d-flex justify-content-between align-items-center p-3 cursor-pointer bg-light"
          @click="expandedBlockId = (expandedBlockId === block.id ? null : block.id)">
          <h5 class="mb-0 font-weight-bold">Template Block {{ bIdx + 1 }}</h5>

          <div class="d-flex align-items-center justify-content-center">
            <AppButton v-if="proposal.approach.blocks && proposal.approach.blocks.length > 1" class="btn-delete" size="sm"
              @click.stop="removeBlock(bIdx)" variant="danger" title="Remove block">
              <fa-icon icon="trash-alt" />
            </AppButton>

            <span class="expanded-icon"
              :style="{ transform: expandedBlockId === block.id ? 'rotate(180deg)' : 'rotate(0deg)' }">
              <span v-html="arrowDownIcon"></span>
            </span>
          </div>
        </div>

        <div v-show="expandedBlockId === block.id" class="p-3 border-top">
          <div class="row">
            <div class="col-12 mb-3">
              <SelectDropdown label="Template" :modelValue="block.template"
                :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
                placeholder="Select Template" @update:modelValue="(val) => handleTemplateSelection(val, block)"
                :isPreviewable="true" />
            </div>
          </div>

          <div class="row">
            <div v-if="block.template && (block.template == 3 || block.template == 6)" class="col-12 col-md-6 mb-3">
              <ProjectsDropdown label="Projects" :modelValue="block.projects"
                @update:modelValue="(val) => handleProjectSelection(val, block)"
                :disabled="!block.template || block.template !== 3 && block.template !== 6" context="approach" />
            </div>
          </div>

          <div v-if="block.template" class="mb-4">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="label">Questions</label>
              <AppButton @click="addQuestion(block)" variant="none" class="btn-add-pill icon" size="sm" :disabled="!block.template" title="Add a question">
			    <fa-icon icon="plus" style="color:green;" />Add a question
              </AppButton>
            </div>
            <p v-if="warnings[block.id]" class="warning-msg">{{ warnings[block.id] }}</p>
            <div v-for="(question, index) in block.questions" :key="question.id"
              class="mb-2 p-2 bg-white rounded-lg border">
              <div class="d-flex justify-content-between align-items-center" role="button"
                @click="toggleQuestion(block.id, index)">
                <label class="label">Question {{ index + 1 }}</label>
                <span v-html="arrowDownIcon" class="collapse-arrow"
                  :class="{ open: openQuestionIndex[block.id] === index }" />
              </div>

              <div v-show="openQuestionIndex[block.id] === index" class="mt-2">
                <InputField class="mb-2" :modelValue="question.heading" placeholder="Enter heading..."
                  @update:modelValue="question.heading = $event" />

                <div class="d-flex align-items-center mb-2">
                  <InputField :modelValue="question.question" placeholder="Enter question and generate response..."
                    @update:modelValue="question.question = $event" />
                  <AppButton :disabled="$store.state.loading.aiGenerate || !question.question.trim()"
                    @click="handleGenerateResponse(question)" variant="primary" size="sm" class="ml-1">
                    {{ $store.state.loading.aiGenerate ? 'Generating' : 'Generate' }}
                  </AppButton>
                </div>
                <TextEditor v-model="question.response" class="mb-2" :class="'template-' + block.template" />

                <AppButton v-if="block.questions && block.questions.length > 1" variant="danger" @click="removeQuestion(block, index)" variant="none"
                  size="sm" class="btn-delete" title="Remove question">
                  <fa-icon icon="trash-alt" />
                </AppButton>
              </div>
            </div>
          </div>

          <div class="row" v-if="block.template && block.style">
            <div v-for="item in [
              { key: 'colorScheme', label: 'Color Scheme' },
              { key: 'heading', label: 'Heading Color' },
              { key: 'label', label: 'Label Color', disabled: !block.template || (block.template !== 3 && block.template !== 6) },
            ]" :key="item.key" class="col-12 col-md-6 col-lg-4 mb-3">
              <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="block.style[item.key]" :label="item.label" />
              <StyleBox v-else :styling="block.style[item.key]" :label="item.label" :disabled="item.disabled" />
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4 d-flex justify-content-center">
        <AppButton  @click="addBlock()" variant="none" class="btn-add-pill icon" title="Add a block">
          <fa-icon icon="plus" style="color:green;" />Add a block
        </AppButton>
      </div>
    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" :emptyMessage="previewText">
      <div v-for="(block, bIdx) in proposal.approach.blocks" :key="block.id || bIdx" class="approach-preview-wrapper">
        <ApprTemp1 v-if="block.template === 1" :questions="block" :pageGap="true" />
        <ApprTemp2 v-if="block.template === 2" :questions="block" :pageGap="true" />
        <ApprTemp3 v-if="block.template === 3" :questions="block" :pageGap="true" />
        <ApprTemp4 v-if="block.template === 4" :questions="block" :pageGap="true" />
        <ApprTemp5 v-if="block.template === 5" :questions="block" :pageGap="true" />
        <ApprTemp6 v-if="block.template === 6" :questions="block" :pageGap="true" />
      </div>
    </PreviewTemplates>
  </div>
</template>

<style lang="scss" scoped>
:deep(.ql-align-center) {
  text-align: center !important;
}

:deep(.ql-align-right) {
  text-align: right !important;
}

:deep(.ql-align-left) {
  text-align: left !important;
}

:deep(p),
:deep(ul),
:deep(ol),
:deep(li) {
  margin: 0px !important;
}

.template-1 :deep(.ql-editor img) {
  max-width: 353.73px !important;
  height: auto !important;
}

.template-2 :deep(.ql-editor img) {
  max-width: 757.46px !important;
  height: auto !important;
}

.template-3 :deep(.ql-editor img) {
  max-width: 233.32px !important;
  height: auto !important;
}

.template-4 :deep(.ql-editor img) {
  max-width: 491.25px !important;
  height: auto !important;
}

.template-5 :deep(.ql-editor img) {
  max-width: 1042.52px !important;
  height: auto !important;
}

.template-6 :deep(.ql-editor img) {
  max-width: 319.16px !important;
  height: auto !important;
}

.cursor-pointer {
  cursor: pointer;
}

.expanded-icon {
  display: inline-flex;
  transition: transform 0.3s ease;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
}

.label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0px;
}

.collapse-arrow {
  margin-left: 8px;
  transition: transform 0.2s;
  font-size: 12px;
  color: #999;
  flex-shrink: 0;

  &.open {
    transform: rotate(180deg);
  }
}

.warning-msg {
  color: white;
  font-size: 12px;
  background: #c53f3f;
  padding: 10px;
  border-radius: 4px;
}

.approach-preview-wrapper {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0px;
  }
}
.btn-delete {
    color: #dc3545;
    text-align: center;
    font-size: 0.8em;
    width: 23px;
    padding: 0.1em 0;
    margin: 0.25em 0;
    margin-left: 0.5em;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: color 0.2s ease, transform 0.15s ease;
}

.btn-delete:hover {
    color: #a71d2a;        /* slightly darker red */
    text-decoration: underline;
    transform: scale(1.15); /* subtle emphasis */
}
.btn-add-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: #e8f8ee;
  border: none;
  border-radius: 50px;
  font-size: 14px;
  color: #1f7a3a;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-add-pill .icon {
  font-size: 16px;
  font-weight: bold;
}

.btn-add-pill:hover {
  background: #dff5e7;
  }
</style>